const PersonalInformation = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 9C0 4.02944 4.02944 0 9 0H31C35.9706 0 40 4.02944 40 9V31C40 35.9706 35.9706 40 31 40H9C4.02944 40 0 35.9706 0 31V9Z"
      fill="#9966FB"
    />
    <path
      d="M22.5 22.5H17.5C14.7387 22.5 12.5 24.7388 12.5 27.5V28.3333C12.5 28.3333 15.1042 29.1667 20 29.1667C24.8958 29.1667 27.5 28.3333 27.5 28.3333V27.5C27.5 24.7388 25.2612 22.5 22.5 22.5Z"
      fill="white"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8333 14.9999C15.8333 12.6987 17.6987 10.8333 19.9999 10.8333C22.3012 10.8333 24.1666 12.6987 24.1666 14.9999C24.1666 17.3012 22.3012 19.9999 19.9999 19.9999C17.6987 19.9999 15.8333 17.3012 15.8333 14.9999Z"
      fill="white"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default PersonalInformation
